import { useApolloClient } from "@apollo/client";
import { get, map } from "lodash";
import { useCallback } from "react";
import { updateTeamAttributes as updateTeamAttributesMutation } from "src/queries/mutations/updateTeamAttributes.graphql";
import { getCanUpdateGroupAttributes, isGroupActive } from "src/util/group";
import eventBus, { EVENTS } from "src/services/eventEmitter";

export const useUpdateTeamAttributes = ({ team }) => {
  const client = useApolloClient();

  const canUpdateTeamAttributes =
    getCanUpdateGroupAttributes(team) && isGroupActive(team);

  const updateTeamAttributes = useCallback(
    async (attrs) => {
      // strip __typename from attributes
      const attributes = map(attrs, (attr) => {
        const { __typename, ...keep } = attr;
        return keep;
      });

      if (get(team, "id")) {
        const response = await client.mutate({
          mutation: updateTeamAttributesMutation,
          variables: {
            groupId: team.id,
            attributes,
          },
        });

        eventBus.emit(EVENTS.GROUP_ATTRS_UPDATED, response.data.group);

        return true;
      }

      return false;
    },
    [client, team]
  );

  return {
    updateTeamAttributes,
    canUpdateTeamAttributes,
  };
};
